import { render } from "./BaseAccordion.vue?vue&type=template&id=c03f9fd0"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__